import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import { db } from '../lib/firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

const teamMembers = [
  {
    name: "이종업",
    role: "대표",
    qualifications: "<p>경기도 부천시 원미구 중동 905-3</p><p> 905-3 Jung-dong, Wonmi-gu, Bucheon-si, Gyeonggi-do</p>",
    imageUrl: "../assets/images/Image_fx (55).jpg"
  }
];

const StudioPage = () => {
  const [histories, setHistories] = useState([]);

  useEffect(() => {
    document.body.setAttribute('data-barba-namespace', 'studio');
    
    // Firebase에서 연혁 데이터 가져오기
    const fetchHistoryData = async () => {
      try {
        // 연혁 데이터 가져오기
        const historyQuery = query(collection(db, 'histories'), orderBy('order', 'asc'));
        const historySnapshot = await getDocs(historyQuery);
        const historyData = historySnapshot.docs.map(doc => doc.data());
        setHistories(historyData);
      } catch (error) {
        console.error('연혁 데이터 가져오기 실패:', error);
        // 에러 발생 시 기존 하드코딩된 데이터 사용
        setHistories([
          {
            year: 2024,
            project: "가평주택",
            description: "주거 건축 - 주택 (변경 및 증축)"
          }
        ]);
      } finally {
        
      }
    };

    fetchHistoryData();

    return () => {
      document.body.removeAttribute('data-barba-namespace');
    };
  }, []);

  return (
    <main id="main" data-barba="container" data-barba-namespace="studio" className="page_wrap m-t-4">
      <section className="hero_studio_wrap">
        <div className="hero_studio_contain">
          <div className="div-block" style={{ height: '300px' }}>
          </div>
          <div className="hero_studio_image u-text-small">
            {/* <div className="hero_studio_text">About</div> */}
            <div data-image-transition-anim="" className="hero_studio_cover">
              <div data-image-cover="" className="g_image_cover"></div>
              <img src="/frontend/assets/images/Image_fx (100).jpg" className="hero_studio_file" alt="A modern building with a minimalist design." />
            </div>
          </div>
          <h1 aria-hidden={true} data-lines-split="" data-animate-scroll="" className="hero_studio_heading u-text-h3">
            저희 FAIRE 323은 협력적인 접근 방식을 취합니다. 스튜디오에서 일하든, 고객 및 파트너와 함께하든, 이 공유된 과정이 당신과 우리의 비전을 반영하는 작업을 만드는 데 도움이 됩니다.
          </h1>
          <h1 className="hero_studio_heading u-text-h3 u-sr-only">
            FAIRE 323에서는 사람과 장소, 형태와 기능성, 비전과 물질성의 독특한 표현인 건축 디자인을 만듭니다.
          </h1>
        </div>
      </section>

      <section className="studio_about_wrap">
        <div className="studio_about_top u-grid-custom">
          <div data-image-reveal="" data-orientation="portrait" id="w-node-cdd6bf44-d8a4-cdf1-d6f3-82ec875822af-a1591a12" className="studio_image_cover is-portrait">
            <div data-image-cover="" className="g_image_cover"></div>
            <img src="../assets/images/Image_fx (56).jpg" alt="A person walking through a modern building with a lot of natural light." className="studio_about_image1" />
          </div>
          <div id="w-node-_8c31dfcc-cf63-2edf-76f4-e26f1cffa8e4-a1591a12" className="studio_about_bottom">
            <div data-image-reveal="" data-orientation="landscape" className="studio_image_cover is-landscape">
              <div data-image-cover="" className="g_image_cover"></div>
              <img src="../assets/images/Image_fx (52).jpg" data-image="" alt="A minimalist living room with a large window and a simple sofa." className="studio_about_image" />
            </div>
            <div className="studio_about_content">
              <div className="studio_content_contain u-text-h3">
                <div className="studio_content_eyebrow">
                  <div data-wf--global-eyebrow--variant="base" className="g_eyebrow u-text-small"></div>
                </div>
                <p aria-hidden={true} data-lines-split="" data-animate-scroll="" className="">
                  <span className="">우리의</span> 디자인 철학은 패시브 디자인 원칙, 신중하게 고려된 계획, 그리고 직관적인 공간 흐름에 기반을 두고 있습니다. 우리는 목적이 있고 세련된 건축을 통해 용이성과 명확성을 도입하여 일상 생활의 복잡성을 해결하려는 의도로 각 프로젝트에 접근합니다.
                </p>
                <p className="u-sr-only">
                  우리의 디자인 철학은 패시브 디자인 원칙, 신중하게 고려된 계획, 그리고 직관적인 공간 흐름에 기반을 두고 있습니다. 우리는 목적이 있고 세련된 건축을 통해 용이성과 명확성을 도입하여 일상 생활의 복잡성을 해결하려는 의도로 각 프로젝트에 접근합니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="studio_team_wrap">
        <div className="studio_team_header u-text-display">
          <div className="studio_team_eyebrow">
            <div data-wf--global-eyebrow--variant="base" className="g_eyebrow u-text-small">(Our team)</div>
          </div>
          <h2 className="studio_team_heading">팀원 소개<br /><span className="studio_team_span">디자인의 주인공들</span></h2>
        </div>
        <div className="studio_team_contain is-mobile">
          <div className="studio_collection_wrap is-mobile w-dyn-list">
            <div role="list" className="studio_collection_list is-mobile u-grid-column-2 w-dyn-items">
              {teamMembers.map((member, index) => (
                <div key={index} role="listitem" className="studio_collection_item is-mobile w-dyn-item">
                  <div data-image-reveal="" data-orientation="portrait" className="studio_headshot_cover">
                    <div data-image-cover="" className="g_image_cover"></div>
                    <img src={member.imageUrl} loading="lazy" data-image="" alt={member.name} className="studio_collection_headshot" />
                  </div>
                  <div className="studio_collection_details">
                    <h3 className="studio_details_name u-text-h4">{member.name}</h3>
                    <div className="u-text-main">{member.role}</div>
                    <div className="studio_details_qualification w-richtext" dangerouslySetInnerHTML={{ __html: member.qualifications }}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="studio_team_contain">
          <div className="studio_members_wrap">
            <div className="studio_members_collection u-grid-landscape w-dyn-list">
              <div id="w-node-_0d775937-b281-1bed-dc99-c2ad3cd54ed8-a1591a12" role="list" className="studio_images_list w-dyn-items">
                {teamMembers.map((member, index) => (
                  <div key={index} data-orientation="portrait" id={`member-image-${index}`} role="listitem" className="studio_members_item w-dyn-item">
                    <div data-content-image="" className="studio_members_cover">
                      <img src={member.imageUrl} loading="lazy" alt={member.name} className="studio_members_image" />
                      <div className="studio_members_richtext u-text-small u-rich-text w-richtext" dangerouslySetInnerHTML={{ __html: member.qualifications }}></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="studio_collection_wrap w-dyn-list">
            <div role="list" className="studio_collection_list w-dyn-items">
              {teamMembers.map((member, index) => (
                <div key={index} data-content-trigger="" role="listitem" className="studio_collection_item w-dyn-item">
                  <div className="studio_collection_contain">
                    <ul id={`member-details-${index}`} className="studio_members_list">
                      <li className="studio_members_contain">
                        <h3 className="studio_members_contain u-text-h2">{member.name}</h3>
                        <div className="u-text-small">{member.role}</div>
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="studio_recognition_wrap">
        <div className="studio_recognition_top u-grid-tablet">
          <div id="w-node-_4bbcd8eb-55eb-0c9f-bc37-e3df081dc1f1-a1591a12" className="studio_top_content">
            <div data-wf--global-eyebrow--variant="base" className="g_eyebrow u-text-small">수상 및 경력</div>
            <p aria-hidden={true} data-lines-split="" data-animate-scroll="" className="studio_top_paragraph u-text-main">
              수상 및 미디어에서의 인정이 목표는 아니지만, 이는 사려 깊은 디자인이 지속적인 영향을 남긴다는 것을 상기시켜 줍니다.
              <br /><span className="u-splittext-spacer"> </span>우리의 프로젝트가 찬사를 받거나 주요 출판물에 소개될 때, 이는 FAIRE 323을 정의하는 헌신, 창의성, 그리고 협업을 반영합니다.
              <br /><span className="u-splittext-spacer"> </span>이는 우리의 고객과 건축 커뮤니티 모두에게 깊이 공감되는 공간에 대한 증거입니다.
            </p>
            <p className="studio_top_paragraph u-text-main u-sr-only">
              수상 및 미디어에서의 인정이 목표는 아니지만, 이는 사려 깊은 디자인이 지속적인 영향을 남긴다는 것을 상기시켜 줍니다.
              <br /><span className="u-splittext-spacer"> </span>우리의 프로젝트가 찬사를 받거나 주요 출판물에 소개될 때, 이는 FAIRE 323을 정의하는 헌신, 창의성, 그리고 협업을 반영합니다.
              <br /><span className="u-splittext-spacer"> </span>이는 우리의 고객과 건축 커뮤니티 모두에게 깊이 공감되는 공간에 대한 증거입니다.
            </p>
          </div>
          <div data-orientation="landscape" data-image-reveal="" id="w-node-_3252faa7-264b-dcdf-63da-c3becb6833ec-a1591a12" className="studio_top_cover">
            <div data-image-cover="" className="g_image_cover"></div>
            <img src="../assets/images/Image_fx (53).jpg" alt="A modern living room with a large window and a view of the city."/>
          </div>
        </div>
        <div className="studio_recognition_bottom">
          <div className="studio_awards_wrap u-grid-tablet">
            <div id="w-node-ffb0684b-cbc0-20a3-36bf-29bfc780108d-a1591a12" className="studio_awards_eyebrow">
              <div data-wf--global-eyebrow--variant="base" className="g_eyebrow u-text-small">연혁</div>
            </div>
            <div id="w-node-_4c7373e0-ac02-f687-ed10-6d98cc631bdd-a1591a12" className="studio_collection_wrap">
              <div className="studio_collection_header u-grid-landscape u-text-small">
                <div id="w-node-fc5f6988-093f-666d-69f6-6163111875d6-a1591a12" className="studio_collection_year">연도</div>
                <div id="w-node-c0cd9b1d-3431-17f3-77bc-6b8e069bc045-a1591a12" className="studio_collection_project">프로젝트</div>
                <div id="w-node-_0307d9fa-3039-8c60-a398-ea941a80cc68-a1591a12" className="studio_collection_award">설명</div>
              </div>
              <div id="w-node-_37cd841f-58c3-207c-b55d-e85673805b1a-a1591a12" className="studio_awards_collection w-dyn-list">
                <div role="list" className="studio_awards_list w-dyn-items">
                  {histories.map((item, index) => (
                    <div key={index} role="listitem" className="studio_awards_item studio_collection_header u-grid-landscape u-text-main w-dyn-item">
                      <div id="w-node-_244939dd-dc39-39d6-c69f-bb7728988153-a1591a12" className="studio_item_year">{item.year}</div>
                      <div id="w-node-a382bfb2-9fa5-0b4f-9870-82e0392a1b02-a1591a12" className="studio_item_project">{item.project}</div>
                      <div id="w-node-_8ce39921-70e5-afe8-cd31-24a5bd640bc4-a1591a12" className="studio_item_award">{item.description}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default StudioPage;
